import { ApiService } from './api.service';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CadastroService {

  constructor(private api: ApiService) {}

  sendCadastroData(data) {
    const endpoint = 'Account/register';
    const route = environment.API_URL + endpoint;
    return this.api.post$(route, data);
  }
}
